import { enableProdMode, isDevMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { register } from "swiper/element/bundle";

import { appConfig } from "~/app.config";
import { AppComponent } from "~/app.component";
import { environment } from "./environments/environment";
import { registerServiceWorker } from "./register-sw";
import packageJson from "../package.json";

if (environment.production) {
  enableProdMode();
}

if (!isDevMode()) {
  registerServiceWorker(packageJson.version);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

register();
